/* eslint-disable import/prefer-default-export */
// LocalStorage handler
import store from 'store';

const exp = 1000 * 60 * 24 * 10; // 10 days
/**
 * set
 * @param {String} key
 * @param {Object} val
 */
export function localStorageSet(key, val) {
  store.set(key, { val, exp, time: new Date().getTime() });
}

/**
 * get
 * @param  {String} key
 * @return {Object}
 */
export function localStorageGet(key) {
  const info = store.get(key);
  if (!info) {
    return null;
  }
  if (new Date().getTime() - info.time > info.exp) {
    return null;
  }
  return info.val;
}

/**
 * Clear all stored data
 * @return {null}
 */
export function localStorageClear() {
  store.clearAll();
}

export function localStorageRemove(item) {
  store.remove(item);
}



// WEBPACK FOOTER //
// ./src/service/localStorage.js